module.exports = __webpack_public_path__ + "img/bg_radio.115ca436.svg";